








































import { Vue, Component } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  components: {
    "client-registration-form": () =>
      import("@/components/app/client/clientRegistrationForm.vue")
  },
  computed: {
    ...mapGetters({
      currentOauthClient: "auth/client/currentOauthClient",
      defaultOauthClient: "auth/client/defaultOauthClient",
      isSupportedOauthClient: "auth/client/isSupportedOauthClient",
      defaultOauthClientRedirect: "auth/client/defaultOauthClientRedirect"
    })
  }
})
export default class Register extends Vue {}
